import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
  PopupRequest,
  RedirectRequest,
  SilentRequest,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: '2febe642-34a1-433d-bd5d-dbcf192551f6',
    authority: 'https://login.microsoftonline.com/5d498adb-87ca-4b08-bd4c-192c2d827031/V2.0',
    redirectUri: '/auth',
    postLogoutRedirectUri: '/',
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const backendTokenRequest = (): SilentRequest => ({
  scopes: [environment.apiScope],
});

export const silentLoginRequest = (loginHint?: string): PopupRequest | SilentRequest => ({
  scopes: ['openid', 'profile', 'email'],
  loginHint,
});
